<app-filter-side-nav #filterSideNav></app-filter-side-nav>

  <div class="order-range-container">
       <div class="header">
         <span><img src="assets/newimages/Back affordance.png" alt="backward" (click)="onBack()"></span>
        <h2 class="title">Order range</h2>
      </div>
       


<!-- IMPORTANT: wrap your date inputs inside the form group -->
<form [formGroup]="dateRangeForm"  class="grid">


  <!-- Calendar B -->
   <label class="field-label">From Date</label>
 
<mat-form-field appearance="outline" class="matform-field">
  <input
    matInput
    [matDatepicker]="pickerB"
    formControlName="pastDate"
    [min]="minDate"
    [max]="maxDate"
    placeholder="Select past date"
  />

  <mat-datepicker-toggle matSuffix [for]="pickerB"></mat-datepicker-toggle>


<mat-datepicker #pickerB>

    <!-- ✅ Footer actions -->
   


<mat-datepicker-actions class="datepicker-footer">
  <div class="datepicker-divider"></div>

  <!-- <div class="footer-left">
    <span><img src="assets/newimages/CalendarClear.png" alt="clear" (click)="onClear('pastDate', pickerB)"></span>
 
  </div> -->

  <div class="footer-right">
<span><img src="assets/newimages/Cancel.png" alt="cancel" (click)="onCancel(pickerB)"></span>
 <!-- <span><img src="assets/newimages/SetDate.png" alt="setDate" (click)="onSet()"></span> -->

 <button
      mat-raised-button
      color="primary"
      class="set-btn"
      matDatepickerApply>
      Set
    </button> 



  </div>

</mat-datepicker-actions>



    <!-- <span><img src="assets/newimages/calendarsetclear.png" alt="select"></span> -->
  </mat-datepicker>
</mat-form-field>

  <!-- Calendar A -->
   <label class="field-label">Current Date</label>
  <mat-form-field appearance="outline" class="matform-field">
 
    <input
      matInput
      [matDatepicker]="pickerA"
      formControlName="currentDate"
      [min]="minDate"
      [max]="maxDate"

      placeholder="Select current date"
    />
    <mat-datepicker-toggle matSuffix [for]="pickerA"></mat-datepicker-toggle>
    <mat-datepicker #pickerA>
      <mat-datepicker-actions class="datepicker-footer">
  <div class="datepicker-divider"></div>

  <!-- <div class="footer-left">
    <span><img src="assets/newimages/CalendarClear.png" alt="clear" (click)="onClear('currentDate', pickerA)"></span>
 
  </div> -->

  <div class="footer-right">
<span><img src="assets/newimages/Cancel.png" alt="cancel" (click)="onCancel(pickerA)"></span>
 <!-- <span><img src="assets/newimages/SetDate.png" alt="setDate" (click)="onSet()"></span> -->

 <button
      mat-raised-button
      color="primary"
      class="set-btn"
      matDatepickerApply>
      Set
    </button> 



  </div>

</mat-datepicker-actions>
    </mat-datepicker>
  </mat-form-field>

</form>

      <div class="spacer"></div>

      <div class="footer">
          <img src="assets/newimages/Viewbutton.png" (click)="applyFilters()" alt="View Results">
          <img src="assets/newimages/clear.png" (click)="clearFilters()" alt="Clear">
      </div>